/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader} from "react-overlay-loader";
import maleAvatar from "../../assets/images/Male-Avatar.png";
import computerIcon from '../../assets/images/computer-icon-hover.png';
import alertsIcon from '../../assets/images/alerts-icon.png';
import * as actions from "../../store/actions";
import {Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";

class Budget extends Component {
    intervalID;
    state = {
        budget: this.props.budget,
        addBudget: false,
        editBudget: false,
        showDelete: false,
        deletedBudget: null,
        editedBudgetId: null,
        editedBudget: null,
        recipient: null,
        dailyQuota: "",
        monthlyQuota: "",
    };

    componentDidMount() {
        // window.$(function () {
        //     window.jcf.replaceAll();
        // });
        window.$(function () {
            window.$('[data-toggle="offcanvas"]').on('click', function () {
                window.$('.offcanvas-collapse').toggleClass('open')
            });

        });

        this.intervalID = setInterval(this.fetchBudgets.bind(this), 30000);
    }

    componentWillMount() {
        this.props.onFetchBudgets(this.props.token)
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            budget: props.budget
        });
    }

    componentWillUnmount() {
        /*
          stop getData() from continuing to run even
          after unmounting this component
        */
        clearInterval(this.intervalID);
    }


    fetchBudgets = () => {
        this.props.onFetchBudgets(this.props.token)
    };
    isReadOnly = () => {
        if (this.props.permissions === null || this.props.permissions === undefined) {
            return false;
        }
        if (this.props.permissions.policies === null || this.props.permissions.policies === undefined) {
            return false;
        }
        //for now we only care about READONLY for all features
        if (this.props.permissions.policies.length === 0) {
            return false;
        }
        let p = this.props.permissions.policies[0];
        if (p.role === "ReadOnly" && p.feature === "All") {
            return true;
        }

        return false;
    };

    handleLogout = () => {
        this.props.onLogout(this.props.token)
    };

    redirectToDashboard = (e) => {
        e.preventDefault();
        this.props.history.push("/dashboard")
    };

    redirectToGcpDashboard = (event) => {
        event.preventDefault();
        this.props.history.push("/gcpDashboard")
    };

    redirectToSettings = (e) => {
        e.preventDefault();
        this.props.history.push("/accountSettings")
    };

    redirectToInstallation = (e) => {
        e.preventDefault();
        this.props.history.push("/installation")
    };

    redirectToXogroups = (event) => {
        event.preventDefault();
        this.props.history.push("/xogroups")
    };

    redirectToScheduler = (event) => {
        event.preventDefault();
        this.props.history.push("/schedulers")
    };

    redirectToAlerts = (e) => {
        e.preventDefault();
        this.props.history.push("/alerts")
    }

    handleAddBudget = (e) => {
        e.preventDefault();
        this.setState({
            addBudget: true,
            dailyQuota: "",
            monthlyQuota: "",
            editedBudget: {
                sendOverrunNotification: true,
                sendWarningNotification: true,
                enforceBudget: true,
                warningThreshold: 75,
                recipients: []
            }
        });

    };


    handleEditBudget = (e, index) => {
        e.preventDefault();
        let s = this.state.budget.budgets[index];

        this.setState({
            editBudget: true,
            editedBudget: s,
            editedBudgetId: index,
            dailyQuota: s.dailyQuota === 0.0 ? "" : "" + s.dailyQuota,
            monthlyQuota: s.monthlyQuota === 0.0 ? "" : "" + s.monthlyQuota,
        });
    };


    handleAddBudgetSubmit = (e) => {
        e.preventDefault();
        let budgets = this.state.budget.budgets.concat(this.state.editedBudget);
        let budget = {...this.state.budget, budgets: budgets};
        this.setState({budget: budget, editedBudget: null, addBudget: false});
        this.props.onUpdateBudget(this.props.token, budget)
    };

    handleEditBudgetSubmit = (e) => {
        e.preventDefault();


        let budgets = [...this.state.budget.budgets.slice(0, this.state.editedBudgetId), this.state.editedBudget, ...this.state.budget.budgets.slice(this.state.editedBudgetId + 1)];
        let budget = {...this.state.budget, budgets: budgets};
        this.setState({
            budget: budget,
            editedBudget: null,
            editedBudgetId: null,
            editBudget: false,
        });
        this.props.onUpdateBudget(this.props.token, budget)
    };


    handleDeleteBudget = (e, index) => {
        e.preventDefault();
        this.setState({showDelete: true, deletedBudget: index})
    };


    toggleAddBudget = () => {
        this.setState({addBudget: !this.state.addBudget})
    };

    toggleEditBudget = () => {
        this.setState({editBudget: !this.state.editBudget})
    };

    toggleShowDelete = () => {
        this.setState({
            showDelete: !this.state.showDelete
        });
    };

    handleCancelDelete = () => {
        this.setState({showDelete: false, deletedBudget: null})
    };

    handleDelete = e => {
        e.preventDefault();
        if (this.state.deletedBudget !== null) {
            let budgets = [...this.state.budget.budgets.slice(0, this.state.deletedBudget), ...this.state.budget.budgets.slice(this.state.deletedBudget + 1)];
            let budget = {...this.state.budget, budgets: budgets};
            this.setState({budget: budget, showDelete: false, deletedBudget: null});
            this.props.onUpdateBudget(this.props.token, budget)
        }
    };

    handleEditBudgetName = (e) => {
        this.setState({editedBudget: {...this.state.editedBudget, name: e.target.value}})
    };

    handleEditBudgetDailyQuota = (e) => {
        let dailyQuota = e.target.value;
        this.setState({
            dailyQuota: dailyQuota,
            editedBudget: {...this.state.editedBudget, dailyQuota: parseFloat(dailyQuota)}
        })
    };

    handleEditBudgetMonthlyQuota = (e) => {
        let monthlyQuota = e.target.value;
        this.setState({
            monthlyQuota: monthlyQuota,
            editedBudget: {...this.state.editedBudget, monthlyQuota: parseFloat(monthlyQuota)}
        })
    };

    handleEditBudgetEnforceBudget = (e) => {
        this.setState({
            editedBudget: {
                ...this.state.editedBudget,
                enforceBudget: !this.state.editedBudget.enforceBudget
            }
        })
    };

    handleEditBudgetNotificationSendTerminationNotification = (e) => {
        this.setState({
            editedBudget: {
                ...this.state.editedBudget,
                sendOverrunNotification: !this.state.editedBudget.sendOverrunNotification
            }
        })
    };

    handleEditBudgetNotificationSendWarningNotification = (e) => {
        this.setState({
            editedBudget: {
                ...this.state.editedBudget,
                sendWarningNotification: !this.state.editedBudget.sendWarningNotification
            }
        })
    };

    handleEditBudgetNotificationWarningThreshold = (e) => {
        this.setState({
            editedBudget: {
                ...this.state.editedBudget,
                warningThreshold: parseInt(e.target.value)
            }
        })
    };

    handleAddNotificationEmail = (e) => {
        let recipients = this.state.editedBudget.recipients || [];
        recipients = recipients.concat(this.state.recipient);
        this.setState({
            editedBudget: {
                ...this.state.editedBudget,
                recipients: recipients
            },
            recipient: "",
        })

    };

    handleEditBudgetNotificationEmail = (e) => {
        this.setState({recipient: e.target.value});
    };

    render() {
        return (
            <div>

                <div className="wrapper">
                    <Loader fullPage={true} loading={this.props.loading}/>
                    <div className="navbar navbar-dark bg-dark d-block d-md-none mob-nav fixed-top">
                        <button className="navbar-toggler pull-right" type="button" data-toggle="offcanvas"><span
                            className="navbar-toggler-icon"></span></button>
                        <div className="nav-item dropdown logo pull-left"><a className="dropdown-toggle text-white"
                                                                             href="http://example.com" id="dropdown10"
                                                                             data-toggle="dropdown" aria-haspopup="true"
                                                                             aria-expanded="false">
                            <div className="company-logo">
                                <div className="inner-logo rounded-circle img-thumbnail"><img src={maleAvatar}
                                                                                              alt="" title=""/></div>
                            </div>
                            {this.props.company}</a>
                            <div className="dropdown-menu" aria-labelledby="dropdown10">
                                <a className="dropdown-item" href="#">{this.props.company}</a>
                                <a className="dropdown-item" href="#" onClick={this.handlerLogout}>Logout</a></div>
                        </div>
                    </div>
                    <div className="sidebar offcanvas-collapse">
                        <div className="sidebar-wrapper">
                            <div className="dropdown logo d-none d-md-block"><a href="/"
                                                                                className="simple-text dropdown-toggle"
                                                                                data-toggle="collapse"
                                                                                data-target="#dropdown11">
                                <div className="company-logo">
                                    <div className="inner-logo rounded-circle img-thumbnail"><img
                                        src={maleAvatar} alt="" title=""/></div>
                                </div>
                                {this.props.company} </a>
                                <div className="dropdown-menu collapse" id="dropdown11">
                                    <a className="dropdown-item" href="#">{this.props.company}</a>
                                    <a className="dropdown-item" href="#" onClick={this.handleLogout}>Logout</a>
                                </div>
                            </div>
                            <ul className="nav">
                                {
                                    this.props.gcpOnly ? null :
                                        (<li><a href="#" onClick={this.redirectToDashboard}> <i className="fa fa-bar-chart"></i>
                                            <p>AWS Dashboard</p>
                                        </a></li>)
                                }
                                {
                                    this.props.hasGcp ?
                                        (
                                            <li><a href="#" onClick={this.redirectToGcpDashboard}> <i className="fa fa-bar-chart"></i>
                                                <p>GCP Dashboard</p>
                                            </a></li>
                                        ) : null
                                }

                                <li><a href="#" onClick={this.redirectToXogroups}> <i className="com-icon"><img
                                    src={computerIcon} alt="" title=""/></i>
                                    <p>Xogroups</p>
                                </a></li>
                                <li className="active"><a href="#"> <i className="fa fa-dollar"></i>
                                    <p>Budgets</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToScheduler}> <i className="fa fa-calendar"></i>
                                    <p>Schedules</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToAlerts}> <i className="com-icon"><img
                                    src={alertsIcon} alt="" title="" width="25"/></i>
                                    <p>Alerts</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToInstallation}> <i className="fa fa-wrench"></i>
                                    <p>Installation</p>
                                </a></li>
                                <li><a href="#" onClick={this.redirectToSettings}> <i className="fa fa-gear"></i>
                                    <p>Settings</p>
                                </a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-panel">
                        <div className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="content">
                                                <div className="header">
                                                    <div className="row no-gutters">
                                                        <div className="col-6">
                                                            <h4 className="title mt-2 mb-3">Budgets</h4>
                                                        </div>
                                                        <div className="col-6 text-right">
                                                            <button type="button" className="btn btn-secondary" disabled={this.isReadOnly()}
                                                                    onClick={e => this.handleAddBudget(e)}
                                                                    data-toggle="modal" data-target="#addBudget">Add
                                                                Budget
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table width="100%" cellPadding="0" cellSpacing="0"
                                                       className="table alt-rows responsive-table">
                                                    <thead>
                                                    <tr>
                                                        <th>Budget Name</th>
                                                        <th>Daily Budget</th>
                                                        <th>Monthly Budget</th>
                                                        <th className="text-center">Edit</th>
                                                        <th className="text-center">Delete</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.props.budget.budgets.map((b, index) => {
                                                        let daily = <div>${b.dailyUsage} used of ${b.dailyQuota}
                                                            <div className="progress mt-1">
                                                                <div className="progress-bar" role="progressbar"
                                                                     style={{width: b.dailyPct + "%"}}
                                                                     aria-valuenow={b.dailyPct}
                                                                     aria-valuemin="0"
                                                                     aria-valuemax="100">{b.dailyPct}%
                                                                </div>
                                                            </div>
                                                        </div>
                                                        if (b.dailyQuota === 0) {
                                                            daily = ""
                                                        }

                                                        let monthly = <div>${b.monthlyUsage} used
                                                            of ${b.monthlyQuota}
                                                            <div className="progress mt-1">
                                                                <div className="progress-bar" role="progressbar"
                                                                     style={{width: b.monthlyPct + '%'}}
                                                                     aria-valuenow={b.monthlyPct}
                                                                     aria-valuemin="0"
                                                                     aria-valuemax="100">{b.monthlyPct}%
                                                                </div>
                                                            </div>
                                                        </div>
                                                        if (b.monthlyQuota === 0) {
                                                            monthly = ""
                                                        }
                                                        return (
                                                            <tr key={index}>
                                                                <td data-title="Budget Name">{b.name}</td>
                                                                <td data-title="Daily Budget">{daily}
                                                                </td>
                                                                <td data-title="Monthly Budget">{monthly}
                                                                </td>
                                                                <td data-title="Edit" align="center" width="80"><a
                                                                    href="#" className="text-primary"
                                                                    onClick={e => this.handleEditBudget(e, index)}
                                                                    data-toggle="modal" data-target="#editBudget"><i
                                                                    className="fa fa-edit fa-x"></i></a></td>
                                                                <td data-title="Delete" align="center" width="80"><a
                                                                    href="#" className="text-danger" data-toggle="modal"
                                                                    onClick={e => {if (this.isReadOnly()) {return false;} else {this.handleDeleteBudget(e, index)}}}
                                                                    data-target="#deleteitem"><i
                                                                    className="fa fa-trash-o fa-x"></i></a></td>
                                                            </tr>
                                                        )


                                                    })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.addBudget} toggle={this.toggleAddBudget} size="exl">
                    <ModalHeader toggle={this.toggleAddBudget}><strong>Add Budget</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-md-12">
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 label text-right">
                                            <label className="mt-2">Budget Name:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8">
                                            <input type="text" className="form-control"
                                                   onChange={e => this.handleEditBudgetName(e)}/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 label text-right">
                                            <label className="mt-2">Daily Budget:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8">
                                            <div className="input-group">
                                                <div className="input-group-prepend"><span className="input-group-text"
                                                                                           id="basic-addon1">$</span>
                                                </div>
                                                <input type="text" className="form-control"
                                                       value={this.state.dailyQuota}
                                                       onChange={e => this.handleEditBudgetDailyQuota(e)}></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 label text-right">
                                            <label className="mt-2">Monthly Budget:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8">
                                            <div className="input-group">
                                                <div className="input-group-prepend"><span className="input-group-text"
                                                                                           id="basic-addon1">$</span>
                                                </div>
                                                <input type="text" className="form-control"
                                                       value={this.state.monthlyQuota}
                                                       onChange={e => this.handleEditBudgetMonthlyQuota(e)}></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 col-auto label text-right">
                                            <label className="mt-2">Enforce Budget:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8 col-auto d-flex align-items-center">
                                            <label className="switch mb-0">
                                                <input type="checkbox"
                                                       defaultChecked={this.state.editedBudget ? this.state.editedBudget.enforceBudget : false}
                                                       onChange={e => this.handleEditBudgetEnforceBudget(e)}/>
                                                <div className="slider round"></div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 col-auto label text-right">
                                            <label className="mt-2">Send Overrun Notifications:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8 col-auto d-flex align-items-center">
                                            <label className="switch mb-0">
                                                <input type="checkbox" id="#NotificationsToggleAdd"
                                                       name="NotificationsToggleAdd"
                                                       defaultChecked={this.state.editedBudget ? this.state.editedBudget.sendOverrunNotification : false}
                                                       onChange={e => this.handleEditBudgetNotificationSendTerminationNotification(e)}/>
                                                <div className="slider round"></div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 col-auto label text-right">
                                            <label className="mt-2">Send Warning Notifications:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8 col-auto d-flex align-items-center">
                                            <label className="switch mb-0">
                                                <input type="checkbox" id="#NotificationsToggleAdd"
                                                       name="NotificationsToggleAdd"
                                                       defaultChecked={this.state.editedBudget ? this.state.editedBudget.sendWarningNotification : false}
                                                       onChange={e => this.handleEditBudgetNotificationSendWarningNotification(e)}/>
                                                <div className="slider round"></div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 col-auto label text-right">
                                            <label className="mt-2">Warning threshold:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8 col-auto d-flex align-items-center">
                                            <div className="number-container">
                                                <input className="form-control" type="number" min="1"
                                                       max="100"
                                                       value={this.state.editedBudget ? this.state.editedBudget.warningThreshold : ""}
                                                       onChange={e => this.handleEditBudgetNotificationWarningThreshold(e)}
                                                       step="1"/>
                                                <div id="inc-button" className="spinner-button"></div>
                                                <div id="dec-button" className="spinner-button"></div>
                                            </div>
                                            <span className="mt-2 ml-2 pull-left">%</span></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 col-auto label text-right">
                                            <label className="mt-2">Recipients:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8">
                                            <div className="input-group">
                                                <input type="text" className="form-control"
                                                       placeholder="Email Address"
                                                       value={this.state.recipient ? this.state.recipient : ""}
                                                       onChange={e => this.handleEditBudgetNotificationEmail(e)}/>
                                                <div className="input-group-append">
                                                    <button type="button"
                                                            className="btn btn-sm btn-primary" onClick={e => {
                                                        this.handleAddNotificationEmail(e)
                                                    }}>Add
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4"></div>
                                        <div className="col-lg-7 col-md-8">
                                            <div className="input-group">
                                                <table width="100%" cellPadding="0" cellSpacing="0"
                                                       className="table alt-rows">
                                                    <tbody>
                                                    {
                                                        (this.state.editedBudget && this.state.editedBudget.recipients) ?
                                                            this.state.editedBudget.recipients.map((email, idx) => {
                                                                return (
                                                                    <tr key={idx}>
                                                                        <td>{email}</td>
                                                                    </tr>
                                                                )
                                                            }) :
                                                            [].map((_, i) => {
                                                                return null
                                                            })

                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row text-right">
                                <div className="col-lg-4 col-md-4"></div>
                                <div className="col-lg-7 col-md-8 text-right">
                                    <button type="button" className="btn btn-primary"
                                            onClick={e => this.handleAddBudgetSubmit(e)}>Add Budget
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.editBudget} toggle={this.toggleEditBudget} size="exl">
                    <ModalHeader toggle={this.toggleEditBudget}><strong>Edit Budget</strong></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-md-12">
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 label text-right">
                                            <label className="mt-2">Budget Name:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8">
                                            <input type="text" className="form-control" disabled={this.isReadOnly()}
                                                   value={this.state.editedBudget ? this.state.editedBudget.name : ""}
                                                   onChange={e => this.handleEditBudgetName(e)}/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 label text-right">
                                            <label className="mt-2">Daily Budget:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8">
                                            <div className="input-group">
                                                <div className="input-group-prepend"><span className="input-group-text"
                                                                                           id="basic-addon1">$</span>
                                                </div>
                                                <input type="text" className="form-control" disabled={this.isReadOnly()}
                                                       value={this.state.dailyQuota}
                                                       onChange={e => this.handleEditBudgetDailyQuota(e)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 label text-right">
                                            <label className="mt-2">Monthly Budget:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8">
                                            <div className="input-group">
                                                <div className="input-group-prepend"><span className="input-group-text"
                                                                                           id="basic-addon1">$</span>
                                                </div>
                                                <input type="text" className="form-control" disabled={this.isReadOnly()}
                                                       value={this.state.monthlyQuota}
                                                       onChange={e => this.handleEditBudgetMonthlyQuota(e)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 col-auto label text-right">
                                            <label className="mt-2">Enforce Budget:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8 col-auto d-flex align-items-center">
                                            <label className="switch mb-0">
                                                <input type="checkbox" disabled={this.isReadOnly()}
                                                       defaultChecked={this.state.editedBudget ? this.state.editedBudget.enforceBudget : false}
                                                       onChange={e => this.handleEditBudgetEnforceBudget(e)}/>
                                                <div className="slider round"></div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 col-auto label text-right">
                                            <label className="mt-2">Send Overrun Notifications:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8 col-auto d-flex align-items-center">
                                            <label className="switch mb-0">
                                                <input type="checkbox" disabled={this.isReadOnly()}
                                                       checked={this.state.editedBudget ? this.state.editedBudget.sendOverrunNotification : false}
                                                       onChange={e => this.handleEditBudgetNotificationSendTerminationNotification(e)}/>
                                                <div className="slider round"></div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 col-auto label text-right">
                                            <label className="mt-2">Send Warning Notifications:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8 col-auto d-flex align-items-center">
                                            <label className="switch mb-0">
                                                <input type="checkbox" id="#NotificationsToggleAdd" disabled={this.isReadOnly()}
                                                       name="NotificationsToggleAdd"
                                                       checked={this.state.editedBudget ? this.state.editedBudget.sendWarningNotification : false}
                                                       onChange={e => this.handleEditBudgetNotificationSendWarningNotification(e)}/>
                                                <div className="slider round"></div>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 col-auto label text-right">
                                            <label className="mt-2">Warning threshold:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8 col-auto d-flex align-items-center">
                                            <div className="number-container">
                                                <input className="form-control" type="number" min="1" disabled={this.isReadOnly()}
                                                       max="100"
                                                       value={this.state.editedBudget ? this.state.editedBudget.warningThreshold : ""}
                                                       onChange={e => this.handleEditBudgetNotificationWarningThreshold(e)}
                                                       step="1"/>
                                                <div id="inc-button" className="spinner-button"></div>
                                                <div id="dec-button" className="spinner-button"></div>
                                            </div>
                                            <span className="mt-2 ml-2 pull-left">%</span></div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4 col-auto label text-right">
                                            <label className="mt-2">Recipients:</label>
                                        </div>
                                        <div className="col-lg-7 col-md-8">
                                            <div className="input-group">
                                                <input type="text" className="form-control" disabled={this.isReadOnly()}
                                                       placeholder="Email Address"
                                                       value={this.state.recipient ? this.state.recipient : ""}
                                                       onChange={e => this.handleEditBudgetNotificationEmail(e)}/>
                                                <div className="input-group-append">
                                                    <button type="button" disabled={this.isReadOnly()}
                                                            className="btn btn-sm btn-primary" onClick={e => {
                                                        this.handleAddNotificationEmail(e)
                                                    }}>Add
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-lg-4 col-md-4"></div>
                                        <div className="col-lg-7 col-md-8">
                                            <div className="input-group">
                                                <table width="100%" cellPadding="0" cellSpacing="0"
                                                       className="table alt-rows">
                                                    <tbody>
                                                    {
                                                        (this.state.editedBudget && this.state.editedBudget.recipients) ?
                                                            this.state.editedBudget.recipients.map((email, idx) => {
                                                                return (
                                                                    <tr key={idx}>
                                                                        <td>{email}</td>
                                                                    </tr>
                                                                )
                                                            }) :
                                                            [].map((_, i) => {
                                                                return null
                                                            })

                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row text-right">
                                        <div className="col-lg-4 col-md-4"></div>
                                        <div className="col-lg-7 col-md-8 text-right">
                                            <button type="button" className="btn btn-primary" disabled={this.isReadOnly()}
                                                    onClick={e => this.handleEditBudgetSubmit(e)}>Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal
                    isOpen={this.state.showDelete}
                    toggle={this.toggleShowDelete}
                    size="lg">
                    <ModalBody>
                        <ModalBody>
                            <div
                                className="modal-body">
                                <div
                                    className="row justify-content-center">
                                    <div
                                        className="col-lg-12 text-center"><i
                                        className="fa fa-warning fa-3x text-warning mt-4"> </i>
                                        <h5 className="mt-4 mb-4">Are you sure you want to delete this item?</h5>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <button type="button" className="btn btn-light" data-dismiss="modal"
                                    aria-label="Close" onClick={this.handleCancelDelete}>Cancel
                            </button>
                            <input type="submit" value="Delete" className="btn btn-primary"
                                   onClick={e => this.handleDelete(e)}></input>
                        </ModalFooter>
                    </ModalBody>
                </Modal>
            </div>)
    }
}

const mapStateToProps = state => {
    return {
        token: state.settings.token || state.login.token,
        loading: state.budget.loading,
        error: state.budget.error,
        company: state.login.company,
        hasGcp: state.login.hasGcp,
        gcpOnly: state.login.gcpOnly,
        budget: state.budget.budget,
        permissions: state.login.permissions,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchBudgets: token => dispatch(actions.fetchBudget(token)),
        onUpdateBudget: (token, budget) => dispatch(actions.saveBudget(token, budget)),
        onLogout: (token) => dispatch(actions.logout(token))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Budget)